import Search from '@components/Search';
import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MusicPageGridPosts from '../MusicPageGridPosts';

interface ContentProps {
  scrollContainerRef?: React.RefObject<HTMLDivElement | null>;
}

export const MusicPageContent = memo(({ scrollContainerRef }: ContentProps) => {
  const { t } = useTranslation();
  // State for genre filtering and search
  const [selectedGenre, setSelectedGenre] = useState<string>('All');
  const [searchQuery, setSearchQuery] = useState<string>('');

  return (
    <div className="flex flex-col h-full pt-0 sm:pt-[10px]">
      {/* Fixed Header Section */}
      <div className="flex-shrink-0">
        <h1 className="text-[32px] sm:text-[40px] px-[24px] font-normal leading-[140%] text-left text-[#fcfcfc] font-['DM_Serif_Text']">
          {t('musicPage.title')}
        </h1>
        <div className="text-[14px] px-[24px] font-normal leading-[140%] text-left text-white/80 pb-4 font-[NapsterSans]">
          {t('musicPage.subtitle')}
        </div>
        <Search
          selectedGenre={selectedGenre}
          onGenreChange={setSelectedGenre}
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
          category="music"
        />
      </div>

      {/* Scrollable Content Section */}
      <div
        ref={scrollContainerRef}
        className="flex-1 overflow-y-auto na-scroll-container">
        <div className="pb-[220px]">
          <MusicPageGridPosts
            isActive
            scrollContainerRef={scrollContainerRef}
            genre={selectedGenre === 'All' ? undefined : selectedGenre}
            search={searchQuery.trim() || undefined}
          />
        </div>
      </div>
    </div>
  );
});

MusicPageContent.displayName = 'MusicPageContent';
